<template>
  <v-carousel hide-delimiter-background hide-delimiters :show-arrows="false"
              :height="$vuetify.breakpoint.smOnly ? '400' : '660'">
    <v-carousel-item :src="require('../assets/slider/slider_bg.png')">
      <v-container style="height: 100%;" :class="$vuetify.breakpoint.xsOnly ? 'px-6' : 'px-10'">
        <v-row style="height: 100%;" :align-content="$vuetify.breakpoint.xsOnly ? 'start' : 'center'">
          <v-col cols="12" sm="6" md="5" align-self="center" :class="$vuetify.breakpoint.xsOnly ? 'my-10' : ''">
            <h1 class="mb-7">
              {{ $t(`${sliderContent.title}`) }}
            </h1>
            <v-btn color="primary" rounded large
                   @click="$router.push(`/${sliderContent.child[0].link_url}`)">
              {{ $t(`${sliderContent.child[0].title}`) }}
            </v-btn>
          </v-col>
          <v-col cols="12" sm="6" md="7" :class="$vuetify.breakpoint.xsOnly ? 'my-10' : ''" align-self="center">
            <v-img :src="require('../assets/slider/tmx_slider_logo_2.png')"
                   :max-height="$vuetify.breakpoint.smAndDown ? '220' : '300'" contain />
          </v-col>
        </v-row>
      </v-container>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
export default {
  name: 'carousel',
  props: {
    sliderContent: Object,
  },
  data() {
    return {
      //
    };
  },
};
</script>

<style scoped>

</style>
